import { NetworkSection } from '../../../core/domain/Network';
import { TagVariant } from './GlobalStateTag';

export const getGlobalStateTagVariant = (row: NetworkSection): TagVariant => {
    if (row.overallState === null || row.overallState === undefined) {
        return 'unknown';
    }

    const rate = row.overallState;

    if (rate < 0.4) return 'bad';
    if (rate < 0.6) return 'averageBad';
    if (rate < 0.8) return 'averageGood';

    return 'good';
};
